import { TableCell, TableRow } from "@mui/material";
import TablePage from "apps/web/src/components/universal/TablePage";
import { EducationResourceEventTableItemFragment } from "apps/web/src/types";
import { PaginationHooks } from "apps/web/src/utils/pagination";
import { EducationResourceViewHistoryTableRows } from "./EducationResourceViewHistoryTableRows";
import { useTranslation } from "react-i18next";

interface EducationResourceTableProps {
  paginationHooks: PaginationHooks;
  rows: readonly EducationResourceEventTableItemFragment[];
  loading: boolean;
  totalRows: number;
  timezone: string;
}

export const EducationResourceViewHistoryTable = ({ paginationHooks, loading, totalRows, rows, timezone }: EducationResourceTableProps) => {
  const { t } = useTranslation();
  return (
    <TablePage
      size="medium"
      tableHeaderRow={
        <TableRow>
          <TableCell>{t("educationResources.viewHistoryTable.date")}</TableCell>
          <TableCell>{t("educationResources.viewHistoryTable.time")}</TableCell>
          <TableCell>{t("educationResources.viewHistoryTable.athleteName")}</TableCell>
        </TableRow>
      }
      tableBodyRows={<EducationResourceViewHistoryTableRows rows={rows} timezone={timezone} />}
      paginationHooks={paginationHooks}
      loading={loading}
      total={totalRows}
    />
  );
};
